// @ts-nocheck
import React from 'react'
import _ from 'lodash'
import cn from 'classnames'
import { connect } from 'react-redux'

import lang from 'lang'
import Form from 'common/components/form'
import {
  changeYceiUserFormField,
  validateField,
} from 'page-modules/dashboard/ycei-members/service/actions'

@connect(
  (state) => ({
    id: state.ycei.addYceiUser.form.data.id,
    email: state.ycei.addYceiUser.form.data.email,
    fullName: state.ycei.addYceiUser.form.data.fullName,
    officePhone: state.ycei.addYceiUser.form.data.officePhone,
    mobilePhone: state.ycei.addYceiUser.form.data.mobilePhone,
    roleId: state.ycei.addYceiUser.form.data.roleId,
    personTypeId: state.ycei.addYceiUser.form.data.personTypeId,
    loading: state.ycei.addYceiUser.form.loading,
    errors: state.ycei.addYceiUser.form.errors,
    personRoles: state.personRoles.items,
    personTypes: state.personTypes.items,
  }),
  (dispatch) => ({
    changeFormField: (key, value) => dispatch(changeYceiUserFormField(key, value)),
    validateField: (field, value, validations) =>
      dispatch(validateField(typeof field === 'string' ? { field, value, validations } : field)),
  }),
)
export default class YceiUserForm extends Form {
  static validations = {
    email: 'nonEmpty email',
    fullName: 'nonEmpty alphanumericWithAccents',
    roleId: 'nonEmpty',
    personTypeId: 'nonEmpty',
  }

  createRoleHandler() {
    return (e) => {
      this.props.changeFormField('roleId', e.target.value)
    }
  }

  createPersonTypeHandler() {
    return (e) => {
      this.props.changeFormField('personTypeId', e.target.value)
    }
  }

  renderPersonRoles() {
    return _.map(this.props.personRoles, (role) => {
      return (
        <label htmlFor={`role-${role.id}`} key={role.id}>
          <input
            name="ruler-role"
            id={`role-${role.id}`}
            type="radio"
            value={role.id}
            checked={this.props.roleId === role.id}
            onChange={this.createRoleHandler()}
            onBlur={this.createFieldValidationHandler('roleId', YceiUserForm.validations.roleId)}
          />{' '}
          {lang.userRoles[role.id]}
        </label>
      )
    })
  }

  renderPersonTypes() {
    return _.map(this.props.personTypes, (personType) => {
      const typeIndex = personType.name.replace(/\s/g, '_').toLowerCase()
      return (
        <label htmlFor={`person-type-${typeIndex}`} key={personType.id}>
          <input
            name="ruler-person-type"
            id={`person-type-${typeIndex}`}
            type="radio"
            value={personType.id}
            checked={this.props.personTypeId === personType.id}
            onChange={this.createPersonTypeHandler()}
            onBlur={this.createFieldValidationHandler(
              'personTypeId',
              YceiUserForm.validations.personTypeId,
            )}
          />{' '}
          {lang.personTypes[typeIndex]}
        </label>
      )
    })
  }

  render() {
    return (
      <form action="">
        <span className={cn('form-error', { 'is-visible': this.props.errors.base })}>
          {this.props.errors.base}
        </span>

        <div className="grid-x grid-margin-x">
          <div className="small-12 cell">
            <label htmlFor="email">{lang.email}</label>
            <input
              id="email"
              type="text"
              value={this.props.email}
              onChange={this.createFieldHandler('email')}
              onBlur={this.createFieldValidationHandler('email', YceiUserForm.validations.email)}
            />
            <span className={cn('form-error', { 'is-visible': this.props.errors.email })}>
              {this.props.errors.email}
            </span>
          </div>
          <div className="small-12 cell">
            <label htmlFor="full-name">{lang.fullName}</label>
            <input
              id="full-name"
              type="text"
              value={this.props.fullName}
              onChange={this.createFieldHandler('fullName')}
              onBlur={this.createFieldValidationHandler(
                'fullName',
                YceiUserForm.validations.fullName,
              )}
            />
            <span className={cn('form-error', { 'is-visible': this.props.errors.fullName })}>
              {this.props.errors.fullName}
            </span>
          </div>
        </div>
        <fieldset className="block-controls">
          <legend>{lang.dashboard.yceiUserForm.rulerOnlineRole}</legend>
          {this.renderPersonRoles()}
        </fieldset>
        <span className={cn('form-error', { 'is-visible': this.props.errors.roleId })}>
          {this.props.errors.roleId}
        </span>
        <fieldset className="block-controls">
          <legend>{lang.dashboard.yceiUserForm.rulerOnlinePersonType}</legend>
          {this.renderPersonTypes()}
        </fieldset>
        <span className={cn('form-error', { 'is-visible': this.props.errors.personTypeId })}>
          {this.props.errors.personTypeId}
        </span>
      </form>
    )
  }
}
